import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStateHandlers } from 'recompose';
import classnames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';

import { Card } from 'components/legacy/Card';

import FiltersList from './FiltersList';
import './SidebarFilters.scss';

export const enhance = withStateHandlers(
	{ modal: null },
	{
		onShowModal: () => (modal) => ({ modal }),
		onHideModal: () => () => ({ modal: null })
	}
);

/**
 * Sidebar filters is an instance of FiltersList, configured for use
 * in the sidebar of the search page
 */

export function SidebarFilters({
	filters, showing, moveInDate, onClose, searchParams,
	onFilter, modal, onHideModal, onShowModal, searchType, storageTypeUrls
}) {
	return (
		<Fragment>
			<div className={classnames('sidebar-filters', { showing })}>
				<Card
					segmentCategory="search interactions"
					header="Filter your search"
				>
					<FiltersList
						listKey="sidebar-filter"
						filters={filters}
						moveInDate={moveInDate}
						searchParams={searchParams}
						onFilter={onFilter}
						onShowModal={onShowModal}
						searchType={searchType}
						showSearchTypeLink
						storageTypeUrls={storageTypeUrls}
					/>
				</Card>
			</div>
			{!!modal &&
				React.createElement(
					modal, {
						showing: true,
						onClose: onHideModal
					}
				)
			}
			<CSSTransition
				classNames="transition-fade-in"
				in={showing}
				unmountOnExit
				timeout={500}
			>
				<button
					type="button"
					className="search-filter-mask"
					onClick={onClose}
				/>
			</CSSTransition>
		</Fragment>
	);
}

SidebarFilters.propTypes = {
	filters: PropTypes.object,
	showing: PropTypes.bool.isRequired,
	modal: PropTypes.func,
	onClose: PropTypes.func.isRequired,
	onFilter: PropTypes.func.isRequired,
	onHideModal: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	moveInDate: PropTypes.string,
	searchType: PropTypes.string,
	searchParams: PropTypes.object.isRequired,
	storageTypeUrls: PropTypes.object.isRequired
};

export default enhance(SidebarFilters);
